export default "__VITE_ASSET__BQ3$1t8p__"